module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Curtains-1053adda8a4973df19106b9a33673c27.svg";